import { NotificationLevel } from "@/client/core/Core.api";
import type { ShowUserNotification } from "@/client/core/Core.api";
import { createErrorMessage } from "@/shared/utils/error";

export const showError = (
    showUserNotification: ShowUserNotification,
    title: string,
    error: unknown,
) => {
    showUserNotification({
        level: NotificationLevel.Error,
        title,
        body: createErrorMessage(error),
    });
    // eslint-disable-next-line no-console
    console.error(title, error);
};

export const showErrorFactory =
    (showUserNotification: ShowUserNotification, title: string) => (error: unknown) =>
        showError(showUserNotification, title, error);

export const showWarning = (
    showUserNotification: ShowUserNotification,
    title: string,
    body: string,
): void => {
    showUserNotification({
        level: NotificationLevel.Warning,
        title,
        body,
    });
};
